/* @flow */
import CurrentUser from 'auth/CurrentUser';
import _ from 'lodash';

const ZOPIM_JS = 'https://v2.zopim.com/?28wHYXfglWj5NGTN8wTxuTFkJztIk18f';

let loadId = null;
let isOnline = false;
let isWindowOpen = false;

function conditionButton() {
  const elements = document.getElementsByClassName('zopim');
  if (elements.length > 0) {
    const isLoggedIn = CurrentUser.isSignedIn();
    // The button is the first element (let's hope it stays that way...)
    elements[0].style.display = isOnline && !isWindowOpen && !isLoggedIn ? '' : 'none';
  }
}

export default class Zopim {
  static load() {
    if (window.$zopim) {
      return Promise.resolve(window.$zopim);
    }

    const $script = require('scriptjs');

    if (!loadId) {
      $script(ZOPIM_JS, loadId = _.uniqueId('zopim'), () => {
        const zopim = window.$zopim;
        if (!zopim) {
          return;
        }

        const livechat = zopim.livechat;

        // Update isOnline state
        livechat.setOnStatus(status => {
          isOnline = status === 'online';
          conditionButton();
        });

        // Subscribe to user change to condition the button
        CurrentUser.addChangeListener(conditionButton);

        // Subscribe to show/hide to condition the button
        livechat.window.onShow(() => {
          isWindowOpen = true;
          conditionButton();
        });
        livechat.window.onHide(() => {
          isWindowOpen = false;
          conditionButton();
        });

        isWindowOpen = !!livechat.window.getDisplay();
        conditionButton();
      });
    }

    return new Promise(resolve => {
      $script.ready(loadId, () => {
        if (window.$zopim) {
          window.$zopim(() => resolve(window.$zopim));
        }
      });
    });
  }

  static show() {
    Zopim.load().then(zopim => {
      zopim.livechat.window.show();
      isWindowOpen = true;
      conditionButton();
    }).catch(e => console.error('Zopim show failed', e));
  }

  static hide() {
    Zopim.load().then(zopim => {
      zopim.livechat.window.hide();
      isWindowOpen = false;
      conditionButton();
    }).catch(e => console.error('Zopim hide failed', e));
  }

  static addStatusListener(listener) {
    Zopim.load().then(zopim => {
      zopim.livechat.setOnStatus(listener);
    }).catch(e => console.error('Zopim addStatusListener failed', e));
  }

  static getCurrentStatus() {
    return isOnline;
  }
}



// WEBPACK FOOTER //
// ./src/lib/Zopim.js